import React from 'react';
import { ReadsTable } from '../ReadsTable';

export const All: React.FC = () => {
  return <ReadsTable />;
};
